import * as types from "./types";

const mutations = {
    [types.LOADING_BANK](state, value) {
        state.loading = value;
    },
    [types.GET_BANK_LIST](state, bank) {
        state.bank = bank;
    },
    [types.GET_BANK_ID](state, id) {
        state.id = id;
    },
    [types.REMOVE_BANK](state, id) {        
        state.bank = state.bank.filter((x) => x.id !== id);        
    },
    [types.ADD_BANK](state, bank) {        
        state.bank.unshift(bank);
    },
    [types.UPDATE_BANK](state, bank) {        
        const bankIndex = state.bank.findIndex((x) => x.id === bank.id);
        state.bank[bankIndex] = bank;        
    }
};

export default mutations;